import { MessagesApiFetchParams } from "@web-src/features/chats/types";

export const getChatPaginationId = (
  chatId?: string,
  fetchParams?: Pick<MessagesApiFetchParams, "attachment_type">
) => {
  if (!fetchParams || fetchParams.attachment_type !== undefined) {
    return `messages:${chatId}:attachment-${fetchParams?.attachment_type}`;
  }
  return `messages:${chatId}`;
};
